import type {
  GetDocumentPagesRequestType,
  GetDocumentPagesResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const getDocumentPages = async (params: GetDocumentPagesRequestType) => {
  const url = `/api/v2/documents/${params.documentId}/pages`;
  const response = await apiAuthClient.get<GetDocumentPagesResponseType>(url);

  return response.data.data;
};
